import TransportLayer from "../plugins/transport";

export default class BaseService {
  resource = null
  transport = null

  constructor(token, baseUrl) {
    this.transport = new TransportLayer(token, baseUrl)
  }

  get(id, params) {
    return this.transport.get(`${this.resource}/${id}`, params);
  }

  list(params) {
    return this.transport.get(`${this.resource}/`, params);
  }
  paginate(options, extra){
    let params = {
      order_by: options.sortBy && options.sortBy[0] ? options.sortBy[0] : 'id',
      sort_order: options.sortDesc && options.sortBy[0] ? 'DESC' : 'ASC',
      unity_id: options.unity_id ? options.unity_id : undefined,
      per_page: options.itemsPerPage,
      page: options.page,
      q: options.q
    }
    params = {...params, ...extra}
     return this.transport.get(`${this.resource}/`, params);
  }

  post(payload) {
    return this.transport.post(`${this.resource}/`, payload);
  }

  patch(id, payload) {
    return this.transport.patch(`${this.resource}/${id}`, payload);

  }

  delete(id, params) {
    return this.transport.delete(`${this.resource}/${id}`, params);
  }
}
